export enum CTAS_WORKFLOW {
  IN_CART,
  BUY,
  TAKEN,
  YOURS,
  MY_DOMAIN,
}
